import Vue from 'vue'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import iView from 'iview'
Vue.use(iView)
import ElementUI from 'element-ui'
Vue.use(ElementUI)
import api from './api/index.js'
Vue.use(api)
import VueQriously from 'vue-qriously'
Vue.use(VueQriously)
import './icons' // icon
import store from './store'
import Cookies from 'js-cookie'
import 'iview/dist/styles/iview.css' // 使用 CSS
import '@/assets/iconfont/iconfont.css'
import './assets/styles/layout/layout.less' // 引入布局样式
import './assets/styles/cover/cover.less' // 覆盖样式
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/base/base.less'
import './assets/css/deviceMap.css'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts


import * as filters from './common/filter'

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'E6jZP5Q9GPxWTiQHAP5FWOsWPq5GyUll'
})

import 'leaflet/dist/leaflet.css';
import * as L from 'leaflet';
import 'leaflet.icon.glyph';
import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});


import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDMqc0gL4e_3OywabsSvVJxa50uVaaCtdE',
    v: '3.23'
  }
})

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

var winWidth = document.documentElement.clientWidth
// 设置当前屏幕分辨率
store.commit('setClientWidth', document.body.clientWidth)
if (winWidth <= 600) {
  store.commit('CLOSE_SLIDEBAR')
} else {
  store.commit('OPEN_SLIDEBAR')
}
window.onresize = function () {
  winWidth = document.documentElement.clientWidth
  if (winWidth <= 600) {
    store.commit('CLOSE_SLIDEBAR')
  } else {
    store.commit('OPEN_SLIDEBAR')
  }
}

import zhLocale from 'iview/src/locale/lang/zh-CN'
import enLocale from 'iview/src/locale/lang/en-US'
import zhmessage from '@/assets/lang/CN/message_zh_cn'
import enmessage from '@/assets/lang/EN/message_en_us'

let lang = Cookies.getJSON('lang')
if (lang && lang.type === 'CN') {
  Vue.config.lang = 'zh-CN'
  store.dispatch('setLang', {icon: '#icon-zhongguo', type: 'CN'})
} else if (lang && lang.type === 'EN') {
  store.dispatch('setLang', {icon: '#icon-yingguo', type: 'EN'})
  Vue.config.lang = 'en-US'
} else {
  Vue.config.lang = 'en-US'
  store.dispatch('setLang', {icon: '#icon-yingguo', type: 'EN'})
}

/*---------使用语言包-----------*/
const mergeZH = Object.assign(zhLocale, zhmessage)
const mergeEN = Object.assign(enLocale, enmessage)
Vue.locale("zh-CN",mergeZH)
Vue.locale("en-US",mergeEN)
// 开启debug模式
Vue.config.debug = true
// import $ from 'jquery'
Vue.config.productionTip = false

import {timeFormat, entityToString, entityToStringForObj} from '@/common/filter';

// 创建全局的字符串转义过滤器
Vue.filter('charConversionFilter', (strValue) => {
  if (typeof strValue === 'string') {
    return entityToString(strValue);
  }
  return strValue;
})

// 创建全局的对象属性过滤器
Vue.filter('objectPropertiesConversionFilter', entityToStringForObj);

// 创建全局的对象属性过滤器
Vue.filter('objectPropertiesCopyFilter', function(obj) {
  let resultObj = {};
  if (typeof obj === 'object') {
    let properties = Object.keys(obj);
    properties.forEach(key => {
      resultObj[key] = obj[key]
    })
  }
  return resultObj;
})
// 创建全局的时间格式化过滤器
Vue.filter('timeFormatFilter', (strValue) => {
  if (typeof strValue === 'number') {
    return timeFormat(strValue);
  }
  return strValue;
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js